<template>
  <div class="login">
    <div
      style="
        position: fixed;
        bottom: 40px;
        color: #ffffff;
        font-size: 28px;
        left: 30px;
      "
    >
      我们一直在拼尽全力的优化！不懈努力的为用户提供更好的选择！
    </div>
    <div class="back">
      <img src="../assets/back.jpg" width="100%" height="100%" alt />
    </div>
    <div class="logo">
      <img src="../assets/logo22.png" alt class="logopic" />
    </div>
    <div class="loginbox" v-show="showLogin">
      <el-tabs v-model="activeName" class="boxtabs">
        <el-tab-pane label="密码登录" name="first"></el-tab-pane>
        <el-tab-pane label="验证码登录" name="second"></el-tab-pane>
      </el-tabs>
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        v-if="activeName == 'first'"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            class="password_input"
            placeholder="密码"
            v-model="loginForm.password"
          >
            <template slot="append">
              <el-button @click="dialogVisible = true">忘记密码</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('loginForm')"
            class="passButton"
            >登陆</el-button
          >
          <p class="register" @click="register">注册</p>
        </el-form-item>
      </el-form>
      <el-form :model="loginForm2" :rules="rules2" ref="loginForm2" v-else>
        <el-form-item prop="phone">
          <el-input v-model="loginForm2.phone" placeholder="手机号">
            <template slot="append">
              <el-button v-show="codeshow" @click="getCode"
                >获取验证码</el-button
              >
              <el-button v-show="!codeshow">{{ count }} s</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            placeholder="验证码"
            class="password_input"
            v-model="loginForm2.code"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="phoneLogin('loginForm2')"
            class="passButton"
            >登陆</el-button
          >
          <p class="register" @click="register">注册</p>
        </el-form-item>
      </el-form>
    </div>
    <input type="button" />
    <el-dialog
      title="忘记密码"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-input
        style="margin-bottom: 10px"
        v-model="loginForm.username"
        placeholder="请输入用户名"
      ></el-input>
      <el-input
        style="margin-bottom: 10px"
        v-model="loginForm2.phone"
        placeholder="请输入手机号"
      >
        <template slot="append">
          <el-button v-show="codeshow" @click="getCode">获取验证码</el-button>
          <el-button v-show="!codeshow">{{ count }} s</el-button>
        </template>
      </el-input>
      <el-input
        style="margin-bottom: 10px"
        v-model="loginForm2.code"
        placeholder="请输入验证码"
      ></el-input>
      <el-input
        style="margin-bottom: 10px"
        v-model="loginForm.password"
        show-password
        placeholder="请输入新密码"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="uppassword()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      dialogVisible: false,
      activeName: "first",
      codeshow: true,
      count: "",
      timer: null,
      loginForm2: {
        phone: "",
        code: "",
      },
      url: localStorage.getItem("url"),
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      rules2: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      showLogin: false,
      // 忘记密码
      username: "",
      password: "",
    };
  },
  created() {
    let token = localStorage.getItem("token");
    if (token) {
      this.showLogin = false;
      this.$router.replace("/information");
    } else {
      this.showLogin = true;
    }
  },
  methods: {
    uppassword() {
      if (this.input == "" || this.input2 == "") {
      } else {
        axios
          .post(
            // `http://pt.zhzymedia.cn/api/client_login/UpdatePassword/v1?username=${this.loginForm.username}&password=${this.loginForm.password}&code=${this.loginForm2.code}`
            `http://pt.zhzymedia.cn/api/client_login/UpdatePassword/v1?username=${this.loginForm.username}&password=${this.loginForm.password}&code=${this.loginForm2.code}`
          )


























          .then((res) => {
            if (res.data.code == 0) {
              this.$alert(res.data.data, "提示", {
                confirmButtonText: "确定",
              }).then(() => {
                this.dialogVisible = false;
                this.changeData("", "", "", "");
              });
            } else {
              this.$alert(res.data.message, "提示", {
                confirmButtonText: "确定",
              });
            }
          });
        // client_user/UpdatePassword/v1?username=123&password=123&newPassword=123
      }
    },
    register() {
      this.$router.replace("/register");
    },
    getCode() {
      var that = this;
      axios
        .get(
          `http://pt.zhzymedia.cn/api/client_login/GetSmsCode/v1?phone=${this.loginForm2.phone}`
          // `http://pt.zhzymedia.cn/api/client_login/GetSmsCode/v1?phone=${this.loginForm2.phone}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeshow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeshow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: res.data.message,
              offset: 100,
            });
          }
        })
        .catch(function (error) {});
      const TIME_COUNT = 59;
    },
    async phoneLogin(formName2) {
      this.$refs[formName2].validate(async (valid) => {
        if (valid) {
          axios
            .post(
              // `http://pt.zhzymedia.cn/api/client_login/LoginByPhone/v1?phone=${this.loginForm2.phone}&code=${this.loginForm2.code}`
              `http://pt.zhzymedia.cn/api/client_login/LoginByPhone/v1?phone=${this.loginForm2.phone}&code=${this.loginForm2.code}`
            )
            .then((res) => {
              if (res.data.code == 0) {
                // localStorage.setItem("token", res.data.data.token);
                this.$notify({
                  title: "成功",
                  message: "登录成功",
                  type: "success",
                });
                localStorage.setItem("username", res.data.data.username);
                localStorage.setItem("token", res.data.data.token);
                this.$router.replace("/information");
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.data.message,
                  offset: 100,
                });
                return false;
              }
            });
        } else {
          this.$notify.error({
            title: "错误",
            message: "请输入正确的手机号和验证码",
            offset: 100,
          });
          return false;
        }
      });
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          axios
            .post(
              // `http://pt.zhzymedia.cn/api/client_login/Login/v1?username=${this.loginForm.username}&password=${this.loginForm.password}`
              `http://pt.zhzymedia.cn/api/client_login/Login/v1?username=${this.loginForm.username}&password=${this.loginForm.password}`
            )
            .then((res) => {
              console.log(res.data);
              if (res.data.code == 0) {
                // localStorage.setItem("token", res.data.data.token);
                this.$notify({
                  title: "成功",
                  message: "登录成功",
                  type: "success",
                });
                localStorage.setItem("isDistribution", res.data.data.isDistribution);
                localStorage.setItem("username", res.data.data.username);
                localStorage.setItem("token", res.data.data.token);
                this.$router.replace("/information");
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.data.message,
                  offset: 100,
                });
                return false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.$notify.error({
            title: "错误",
            message: "请输入正确的用户名密码",
            offset: 100,
          });
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
// @import "../style/mixin";
* {
  margin: 0;
  padding: 0;
}
a {
  color: #ff0000;
}
.back {
  width: 100%;
  height: 100%;
  z-index: -1;
  position: absolute;
}
.logo {
  position: absolute;
  left: 139px;
}
.logopic {
  width: 206px;
  /* height: 162px; */
}
.loginbox {
  background-color: rgba(255, 255, 255, 0.95);
  width: 360px;
  min-height: 295px;
  position: absolute;
  top: 28%;
  right: 170px;
  border-radius: 6px;
  padding: 20px;
}
.boxtabs {
  margin-top: 20px;
}
.passLogin {
  margin-top: 5px;
}
.password_input {
  margin-top: 16px;
}
/* .registerchecked{
    margin-left: 36px;
} */
.passButton {
  width: 100%;
  margin-top: 16px;
  height: 36px;
}
.register {
  font-size: 14px;
  color: #000000;
  margin-top: 10px;
  text-align: center;
}
.registerBox {
  width: 300px;
  height: 435px;
  background-color: rgba(255, 255, 255, 0.95);
  position: absolute;
  top: 85px;
  right: 170px;
  border-radius: 6px;
  padding: 30px 30px 0px 30px;
}
.regButton {
  /* margin-left: 36px; */
  width: 286px;
  margin-top: 12px;
}

.el-form-item {
  margin-bottom: 12px;
}
/deep/.el-form-item__error {
  font-size: 10px;
  padding-top: 1px;
}
.el-form--inline .el-form-item {
  margin-right: 0px;
}
</style>